import React from 'react'
import { FinancingProductError } from '@/components/composed/financing/FinancingProductError'
import type { TFinancingRequestStepperErrorComponentProps } from '@/components/composed/financing/FinancingRequestStepper/types'
import { FinancingConsultingWrapper } from '../FinancingConsultingWrapper'
import './styles.scss'

export const FinancingConsultingError = ({ onResetForm }: TFinancingRequestStepperErrorComponentProps<{}>) => (
  <FinancingConsultingWrapper isFollowingStep>
    <FinancingProductError className="financingConsultingError" onResetStep={onResetForm} />
  </FinancingConsultingWrapper>
)
